import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { DepartmentTypeProps } from '@/models/DepartmentType';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function useDepartmentType() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getDepartmentTypes = useCallback(async (): Promise<DepartmentTypeProps[] | null> => {
    const fetchUrl = `${baseUrl}departmentTypes`;

    const response = await customFetch<DepartmentTypeProps[]>(fetchUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });

    return response;
  }, [authResult, customFetch]);

  return {
    getDepartmentTypes,
  };
}
